import { IIntegrationSetup, IUsers } from "../interfaces";

class CompanyModel {
  public readonly uid: string;
  public name: string;
  public image?: string;
  public users: IUsers;
  public integrationSetup?: IIntegrationSetup;
  public readonly createdAt: Date;
  public modifiedAt: Date;

  constructor(
    uid: string,
    name: string = "",
    image: string = "",
    users: IUsers = {},
    integrationSetup: IIntegrationSetup = {
      software: "",
      host: "",
      user: "",
      password: "",
      tenantId: "",
    },
    createdAt = new Date(),
    modifiedAt = new Date()
  ) {
    this.uid = uid;
    this.name = name;
    this.image = image;
    this.users = users;
    this.integrationSetup = integrationSetup;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
  }

  toSave() {
    return {
      name: this.name,
      image: this.image,
      users: this.users,
      integrationSetup: { ...this.integrationSetup },
      createdAt: this.createdAt,
      modifiedAt: this.modifiedAt,
    };
  }

  static create(uid: string, data: Partial<CompanyModel>): CompanyModel {
    return new CompanyModel(
      uid,
      data.name,
      data.image,
      data.users,
      data.integrationSetup,
      data.createdAt,
      data.modifiedAt
    );
  }

  static createBlank(userUid: string) {
    return new CompanyModel("", "", "", { [userUid]: 0 });
  }
}

export default CompanyModel;
